import { useRef, useState, useEffect, useCallback } from "react";
import api from "../../api";
import { checkPermissionStatus } from "helpers/utils";
import MultiProgress, { ProgressComponentProps } from "react-multi-progress";
import video_icon4 from "../../assets/images/icon/video44.svg";
import delete_icon from "../../assets/images/icon/delete.svg";
import { Link } from "react-router-dom";

export const GetUserListColumns = setVideoUrl => {
  const toggleVideoPopup = link => {
    setVideoUrl(link);
  };

  const copyUrl = async link => {
    const unsecuredCopyToClipboard = text => {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand("copy");
      } catch (err) {
        console.error("Unable to copy to clipboard", err);
      }
      document.body.removeChild(textArea);
    };

    if (window?.isSecureContext && navigator?.clipboard) {
      await navigator?.clipboard?.writeText(link);
    } else {
      unsecuredCopyToClipboard(link);
    }
  };

  const handleSentimentDelete = userId => {
    if (window.confirm("Are you sure you want to delete this Record?")) {
      api
        .delete(
          `${process.env.REACT_APP_API_URL}/sentiment/admin/delete-sentiment/${userId}`
        )
        .then(response => {
          let { status } = response.data;
          if (status) {
            window.location.reload();
          }
        })
        .catch(err => {
          console.log("Error while deleting the user list:::", err);
        });
    }
  };

  let resultArr = [
    {
      dataField: "fullName",
      text: "Full Name",
    },
    {
      dataField: "email",
      text: "Email",
    },
    // Transcript Based Analysis
    {
      dataField: "",
      text: "Enthusiastic",
      formatter: (cell, value) => {
        let enthusiastic = Number(value.Sentiment_data?.enthusiastic) || 0;
        return `${Math.round(enthusiastic)} %`;
      },
      // classes: "Enthusiastic",
      headerClasses: "Enthusiastic",
      // hidden: !value.Sentiment_data?.enthusiastic,
    },
    {
      dataField: "",
      text: "Engaging",
      formatter: (cell, value) => {
        let engaging = Number(value.Sentiment_data?.engaging) || 0;
        return `${Math.round(engaging)} %`;
      },
      // classes: "Engaging",
      headerClasses: "Enthusiastic",
    },
    {
      dataField: "",
      text: "Positive",
      formatter: (cell, value) => {
        let confidence = Number(value.Sentiment_data.positive) || 0;
        return `${Math.round(confidence)} %`;
      },
      // classes: "Positive",
      headerClasses: "Enthusiastic",
    },
    {
      dataField: "",
      text: "Negative",
      formatter: (cell, value) => {
        let angry = Number(value.Sentiment_data?.negative) || 0;
        return `${Math.round(angry)} %`;
      },
      // classes: "Negative",
      headerClasses: "Enthusiastic",
    },
    {
      dataField: "",
      text: "Aws Neutral",
      formatter: (cell, value) => {
        let transcript = Number(value.Sentiment_data?.aws_neutral) || 0;
        return `${Math.round(transcript)} %`;
      },
      // classes: "AwsNeutral",
      headerClasses: "Enthusiastic",
    },
    // Expression Based Analysis
    {
      dataField: "",
      text: "Neutral",
      formatter: (cell, value) => {
        let engaging = Number(value.Sentiment_data?.neutral) || 0;
        return `${Math.round(engaging)} %`;
      },
      // classes: "Neutral",
      headerClasses: "Engaging",
    },
    {
      dataField: "",
      text: "Surprised",
      formatter: (cell, value) => {
        let confidence = Number(value.Sentiment_data.surprised) || 0;
        return `${Math.round(confidence)} %`;
      },
      // classes: "Surprised",
      headerClasses: "Engaging",
    },
    {
      dataField: "",
      text: "Happy",
      formatter: (cell, value) => {
        let confidence = Number(value.Sentiment_data.confidence) || 0;
        return `${Math.round(confidence)} %`;
      },
      // classes: "Happy",
      headerClasses: "Engaging",
    },
    {
      dataField: "",
      text: "Sad",
      formatter: (cell, value) => {
        let confused = Number(value.Sentiment_data.confused) || 0;
        return `${Math.round(confused)} %`;
      },
      // classes: "Sad",
      headerClasses: "Engaging",
    },
    {
      dataField: "",
      text: "Nervous",
      formatter: (cell, value) => {
        let fearful = Number(value.Sentiment_data?.fearful) || 0;
        return `${Math.round(fearful)} %`;
      },
      // classes: "Nervous",
      headerClasses: "Engaging",
    },
    {
      dataField: "",
      text: "Angry",
      formatter: (cell, value) => {
        let engaging = Number(value.Sentiment_data?.angry) || 0;
        return `${engaging} %`;
      },
      // classes: "Angry",
      headerClasses: "Engaging",
    },

    //Tonality Based Analysis
    {
      dataField: "",
      text: "Tonality Angry",
      formatter: (cell, value) => {
        let engaging = Number(value.Sentiment_data?.audio_data?.angry) || 0;
        return `${Math.round(engaging)} %`;
      },
      // classes: "TonalityAngry",
      headerClasses: "Angry",
    },
    {
      dataField: "",
      text: "Tonality Calm",
      formatter: (cell, value) => {
        let engaging = Number(value.Sentiment_data?.audio_data?.calm) || 0;
        return `${Math.round(engaging)} %`;
      },
      // classes: "TonalityCalm",
      headerClasses: "Angry",
    },
    {
      dataField: "",
      text: "Tonality Neutral",
      formatter: (cell, value) => {
        let engaging = Number(value.Sentiment_data?.audio_data?.neutral) || 0;
        return `${Math.round(engaging)} %`;
      },
      // classes: "TonalityNeutral",
      headerClasses: "Angry",
    },
    {
      dataField: "",
      text: "Tonality Happy",
      formatter: (cell, value) => {
        let engaging = Number(value.Sentiment_data?.audio_data?.happy) || 0;
        return `${Math.round(engaging)} %`;
      },
      // classes: "TonalityHappy",
      headerClasses: "Angry",
    },
    {
      dataField: "",
      text: "Tonality Sad",
      formatter: (cell, value) => {
        let engaging = Number(value.Sentiment_data?.audio_data?.sad) || 0;
        return `${Math.round(engaging)} %`;
      },
      // classes: "TonalitySad",
      headerClasses: "Angry",
    },
    {
      dataField: "",
      text: "Tonality Surprised",
      formatter: (cell, value) => {
        let engaging = Number(value.Sentiment_data?.audio_data?.surprise) || 0;
        return `${Math.round(engaging)} %`;
      },
      // classes: "TonalitySurprised",
      headerClasses: "Angry",
    },
    {
      dataField: "",
      text: "Tonality Fear",
      formatter: (cell, value) => {
        let engaging = Number(value.Sentiment_data?.audio_data?.fear) || 0;
        return `${Math.round(engaging)} %`;
      },
      // classes: "TonalityFear",
      headerClasses: "Angry",
    },
    {
      dataField: "",
      text: "Behavioural Score",
      formatter: (cell, value) => {
        let engaging = Number(value.Sentiment_data?.behavioural_score) || 0;
        return `${Math.round(engaging)} %`;
      },
      // classes: "BehaviouralScore",
      headerClasses: "AwsNeutral",
    },
    {
      dataField: "",
      text: "Attentivene Score",
      formatter: (cell, value) => {
        let transcript = Number(value.Sentiment_data?.attention_score) || 0;
        return `${Math.round(transcript)} %`;
      },
      // classes: "AttentivenessScore",
      headerClasses: "AwsNeutral",
    },
    {
      dataField: "istTime",
      text: "Submited On (AEST)",
      sort: true,
    },
  ];

  if (checkPermissionStatus("video-sentiment", "edit")) {
    resultArr.push({
      dataField: "id",
      text: "Actions",
      formatter: (cell, value) => {
        return (
          <>
            <div className="d-flex gap-1 blue-icon-gap action-application">
              <div
                className="action-one small-img pso"
                onClick={() => toggleVideoPopup(value?.video)}
              >
                <div className="text-success blue-icon blue-color4">
                  <img src={video_icon4} alt="edit_icon" />
                  <span>View Video</span>
                </div>
              </div>

              <div className="action-one small-img">
                <div
                  className="text-success blue-icon blue-color3"
                  onClick={() => handleSentimentDelete(cell)}
                  style={{ cursor: "pointer" }}
                  title="Delete User"
                >
                  <img src={delete_icon} alt="delete_icon" />
                  <span>Delete</span>
                </div>
              </div>
            </div>
          </>
        );
      },
    });
  }

  return resultArr;
};
